import React, { useContext, useEffect, useState } from "react";
import "./Venues.css";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { routeNames } from "../../constants/routeNames";
import { SelectBox } from "../../components/SelectBox/SelectBox";
import Api from "../../api/Api";
import { errorHandler } from "../../helpers/errorHelper";

export const Venues = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);
  const [geoPermission, setGeoPermission] = useState(false);
  const [venueList, setVenueList] = useState([]);
  const [userData, setUserData] = useState({});
  const [coordinates, setCoordinates] = useState({});
  const [locationDenied, setLocationDenied] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location?.state?.redirected && location?.state?.userData) {
      setTitle("SELECT YOUR LOCATION");
      setGeoPermission(location?.state?.locationPermission);
      setCoordinates(location?.state?.coordinates);
      setUserData(location?.state?.userData);
      setLoading(false);
      if (location?.state?.locationDenied) {
        setLocationDenied(true);
      }
    } else {
      navigate(routeNames.LANDING);
    }
  }, []);

  useEffect(() => {
    if (geoPermission && coordinates) {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
      Api.getNearVenues(coordinates)
        .then((res) => {
          setVenueList(res?.data);
        })
        .catch((e) => {
          setGeoPermission(false);
        });
    }
  }, [geoPermission]);

  const initVenueCards = () => {
    if (venueList.length > 0) {
      const venueArray = [];
      venueList.forEach((venue, index) => {
        venueArray.push(
          <div
            key={index}
            className={`venue-card ${
              index === venueList.length - 1 ? "last" : ""
            }`}
          >
            <label className="w-100 d-flex flex-row">
              <input
                type="radio"
                name="venue"
                value={venue._id}
                className="venue-checkbox"
                onClick={onVenueSelect}
              />
              <div className="venue-content">
                <h2 className="venue-name">{venue.name}</h2>
                <p className="venue-address">{venue.fullAddress}</p>
              </div>
            </label>
          </div>
        );
      });
      return venueArray;
    }
  };

  const resetVenue = () => {
    const data = { ...userData };
    data["venue"] = null;
    setUserData(data);
  };

  const showAllVenues = () => {
    resetVenue();
    setGeoPermission(false);
  };

  const onLocationSuccess = (pos) => {
    resetVenue();
    const crd = pos.coords;
    setCoordinates({
      longitude: crd?.longitude,
      latitude: crd?.latitude,
    });
    setGeoPermission(true);
  };

  const noLocation = () => {
    resetVenue();
    setGeoPermission(false);
    setLocationDenied(true);
  };

  const askLocation = () => {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    navigator.geolocation.getCurrentPosition(
      onLocationSuccess,
      noLocation,
      options
    );
  };

  const onVenueSelect = (e) => {
    const { name, value } = e.target;
    const data = { ...userData };
    data[name] = value;
    setUserData(data);
    e.stopPropagation();
    const selected = document.getElementsByClassName("venue-card-active");
    if (selected) {
      selected[0]?.classList?.remove("venue-card-active");
    }
    e.target.parentElement.classList.add("venue-card-active");
  };

  const onVenueChange = (value) => {
    const data = location?.state?.userData;
    data["venue"] = value;
    setUserData(data);
  };

  const submitForm = async () => {
    const data = { ...userData };
    if (data.venue === "" || !data.venue) {
      return;
    }
    if (data) {
      const response = await Api.register(data);
      if (response?.result && response?.data) {
        setLoading(true);
        navigate(routeNames.SUCCESS, {
          state: {
            redirected: true,
          },
        });
      } else {
        setLoading(true);
        errorHandler(response, navigate);
      }
    }
  };

  return (
    <div>
      {geoPermission && (
        <h2 className="title register-title" style={{ fontWeight: "400" }}>
          Select your Greene King Pub from the list of closest pubs below.
        </h2>
      )}

      {!geoPermission && (
        <p className="location-description" style={{ marginBottom: "32px" }}>
          Search for your location using its name, or the first half of its
          postcode and select your Greene King Pub from the list below.
        </p>
      )}

      {geoPermission && (
        <div className="text-center ">
          {venueList && venueList?.length > 0 && initVenueCards()}
          {venueList?.length === 0 && (
            <p className="field-error">There are no venues near you.</p>
          )}

          {venueList?.length > 0 && (
            <div className="text-center">
              <Button className="cc-button venue-btn" onClick={submitForm}>
                Enter
              </Button>
            </div>
          )}

          <h2
            className="title"
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "24px",
            }}
          >
            Can’t find the location you’re looking for?
          </h2>
          <p
            className="custom-select-venue-desc venue-choose-option mb-0"
            onClick={showAllVenues}
          >
            Show me all venues
          </p>
        </div>
      )}

      {!geoPermission && (
        <div className="text-center">
          <SelectBox
            onVenueChange={onVenueChange}
            showAllVenues={showAllVenues}
            askLocation={askLocation}
            locationDenied={locationDenied}
            submitForm={submitForm}
          />
        </div>
      )}
    </div>
  );
};
